/*
 * Vremou cookievoorkeuren
 * ---------------------------------------------------------------
 * Opent opnieuw de OFFICIELE Shopify Customer Privacy-banner.
 * Er wordt bewust geen eigen cookiebanner gebouwd: toestemming is
 * wettelijk geregeld via Shopify zelf. Dit knopje roept alleen de
 * ondersteunde API aan.
 *
 * Zonder die API (bijvoorbeeld wanneer de banner in Shopify Admin
 * uitstaat) verbergt de knop zichzelf, zodat er nooit een knop
 * staat die niets doet.
 */

class VremouCookiePrefs extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', () => this.openPreferences());
    this.ensureApi();
  }

  ensureApi() {
    if (window.Shopify && window.Shopify.customerPrivacy) return;

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      this.hide();
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (error || !window.Shopify.customerPrivacy) this.hide();
      }
    );
  }

  hide() {
    this.setAttribute('hidden', '');
  }

  openPreferences() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;

    if (privacy && typeof privacy.showPreferences === 'function') {
      privacy.showPreferences();
      return;
    }

    // Sommige winkels tonen alleen de volledige banner opnieuw.
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return;
    }

    if (window.privacyBanner && typeof window.privacyBanner.loadBanner === 'function') {
      window.privacyBanner.loadBanner();
      return;
    }

    this.hide();
  }
}

if (!customElements.get('vremou-cookie-prefs')) {
  customElements.define('vremou-cookie-prefs', VremouCookiePrefs);
}
